<mat-sidenav-container class="shell__container">
    <mat-sidenav
        id="shell-nav"
        class="shell__nav"
        [mode]="navMode()"
        [opened]="navOpened()"
        [disableClose]="!isCompact()"
        (closedStart)="closeMobileNav()"
    >
        <app-sidebar
            [collapsed]="railCollapsed()"
            [userName]="userName()"
            [roleName]="roleName()"
            (navToggled)="toggleNav()"
            (logoutRequested)="logout()"
        />
    </mat-sidenav>

    <mat-sidenav-content class="shell__body">
        @if (isCompact()) {
            <header class="shell__topbar">
                <button
                    type="button"
                    class="shell__topbar-button"
                    aria-controls="shell-nav"
                    aria-label="Открыть меню разделов"
                    [attr.aria-expanded]="mobileNavOpen()"
                    (click)="toggleNav()"
                >
                    <app-nav-icon name="menu" />
                </button>
                <span class="shell__topbar-title">Независимая оценка качества услуг</span>
            </header>
        }

        <main class="shell__content">
            <router-outlet />
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>
